import ConditionDeviationAssetField from 'components/ConditionDeviation/ConditionDeviationForm/components/ConditionDeviationAssetField/ConditionDeviationAssetField';
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Loading, SecondaryButton } from '@shape-ds/components';
import useNotificationForm from 'components/Notifications/hooks/useNotificationForm';
import { useFeatureFlag } from '@shape/feature-flag';
import { NotificationSwitch } from './NotificationSwitch';
import AssetModelsSelect from './AssetModelsSelect';
import FrequencySelect from './FrequencySelect';

const notificationFields = ['asset_id', 'model', 'frequency', 'email', 'whatsapp'];

const NotificationForm: React.FC = () => {
  const { t } = useTranslation();
  const { formMethods, onSubmit, isMutating } = useNotificationForm();
  const isWhatsAppEnabled = useFeatureFlag('feat-notifications-wpp');
  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={onSubmit}
        className={`notifications-form ${isWhatsAppEnabled ? 'notifications-form-whatsapp' : ''}`}
      >
        <strong className="notifications-form-title">
          {t('components:notifications.form.title')}
        </strong>
        {notificationFields.map((field) => {
          switch (field) {
            case 'asset_id':
              return <ConditionDeviationAssetField key={field} />;
            case 'model':
              return <AssetModelsSelect key={field} assetId={formMethods.watch('asset_id')} />;
            case 'frequency':
              return <FrequencySelect key={field} showLabel />;
            case 'email':
            case 'whatsapp':
              if (!isWhatsAppEnabled) return null;
              return <NotificationSwitch name={field} key={field} showLabel />;
            default:
              return null;
          }
        })}
        <SecondaryButton
          type="submit"
          endIcon={isMutating && <Loading size="14px" />}
          disabled={isMutating || !formMethods.formState.isValid}
          className="notifications-button notifications-button-add"
        >
          {t('components:notifications.form.buttons.add')}
        </SecondaryButton>
      </form>
    </FormProvider>
  );
};

export default NotificationForm;
